import { useRouteError,Link } from "react-router-dom";


export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <div id="error-page" style={styles.container}>
            <h1 style={styles.heading}>Oops! Something went wrong</h1>

            <p style={styles.paragraph}>Sorry, an unexpected error occurred</p>
            <h3 style={styles.subHeading}>Reason</h3>
            <p style={styles.paragraph}>
                <i>{error.statusText || error.messages}</i>
            </p>

            <Link to="/">Return to Home</Link>
        </div>
    )
}

const styles = {
    container: {
        textAlign: 'center',
        margin: 'auto',
        maxWidth: '600px',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
    },
    heading: {
        fontSize: '32px',
        color: '#333',
    },
    paragraph: {
        fontSize: '18px',
        color: '#666',
        margin: 30
    },
    subHeading: {
        fontSize: '24px',
        color: '#444',
    },
};